window.addEventListener('load', function () {

    // неразрывные пробелы всем p
    function addNbsp(str) {
        let prepositions = ["без", "между", "под", "в", "на", "по", "вокруг", "о", "по", "про", "и", "для", "со"];
        return str.replace(/(\S+?)( )/g, (_, p) =>
            p + (prepositions.includes(p.toLowerCase()) ? '\u00A0' : ' '))
    }

    var paragraphs = document.querySelectorAll('p');
    for (let paragraph of paragraphs) {
        paragraph.innerHTML = addNbsp(paragraph.innerHTML);
    }

});